// import config from 'config';
import axios from 'axios';
import { handleResponse } from './http-utils';

export const refLifecycleStateService = {
    getByAccount,
    getById,
    add,
    update,
    deleteEntity
};

function getByAccount(accountId) {
    // return axios.get(`/areas/?accountId=${accountId}`).then(handleResponse);
    return axios.get(`/refLifecycleStates/`).then(handleResponse);
}

function getById(id) {
    return axios.get(`/refLifecycleStates/${id}`).then(handleResponse);
}

function add(refLifecycleState) {
    return axios.post('/refLifecycleStates', refLifecycleState).then(handleResponse);
}

function update(refLifecycleState) {
    return axios.put(`/refLifecycleStates/${refLifecycleState.refLifecycleStateId}`, refLifecycleState).then(handleResponse);
}

function deleteEntity(refLifecycleState) {
    return axios.delete(`/refLifecycleStates/${refLifecycleState.refLifecycleStateId}`).then(handleResponse);
}
